import React from "react";
import PropTypes from "prop-types";

import * as utils from "utils.js";

function NumSpan(props){
	var {prefix, value, precision, suffix} = props;
	var str = value.toString().trim();
	value =  utils.round(Number(str), precision);
	str = value.toString().replace(".", ",");
	if (prefix) {
		str = prefix + str;
	}
	if (suffix) {
		str = str + suffix;
	}
	return (<span>{str}</span>);
}

NumSpan.propTypes = {
	prefix: PropTypes.string,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	precision: PropTypes.number,
	suffix: PropTypes.string
};

export default NumSpan;


// WEBPACK FOOTER //
// ./src/components/NumSpan.jsx